/** Lê flag booleana de env (`true` / `1`), com trim e aspas opcionais. */
export function readEnvFlag(name: string): boolean {
  let raw = process.env[name]?.trim().toLowerCase()
  if (!raw) return false
  if (
    (raw.startsWith('"') && raw.endsWith('"')) ||
    (raw.startsWith("'") && raw.endsWith("'"))
  ) {
    raw = raw.slice(1, -1).trim()
  }
  return raw === "true" || raw === "1"
}
